import React from "react";

export default function Main() {
  return (
    <div className="agn-main-steps-wrapper">
      <style>{`
        .agn-main-steps-wrapper {
          padding: var(--section-padding);
          background: #ffffff;
        }

        .agn-step-card {
          position: relative;
          width: 100%;
          padding-top: 110%; /* Hexagon aspect ratio */
          margin: 15px 0;
          transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
        }

        .agn-step-card:hover {
          transform: translateY(-10px);
        }

        /* The Hexagon Background */
        .agn-step-inner {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: #ffffff;
          clip-path: polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%);
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 25px;
          text-align: center;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
          z-index: 2;
        }

        /* Border effect using pseudo-element */
        .agn-step-card::before {
          content: '';
          position: absolute;
          top: -2px;
          left: -2px;
          right: -2px;
          bottom: -2px;
          background: var(--theme-color);
          clip-path: polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%);
          z-index: 1;
          opacity: 0.3;
          transition: all 0.4s ease;
        }

        .agn-step-card:hover::before {
          opacity: 1;
          transform: scale(1.05);
        }

        .agn-step-icon-box {
          width: 50px;
          height: 50px;
          background: rgba(var(--theme-color-rgb), 0.1);
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 20px;
          transition: all 0.3s ease;
        }

        .agn-step-card:hover .agn-step-icon-box {
          background: var(--theme-color);
          transform: scale(1.1);
        }

        .agn-step-icon-box img {
          width: 24px;
          filter: grayscale(1) brightness(0.5);
          transition: all 0.3s ease;
        }

        .agn-step-card:hover .agn-step-icon-box img {
          filter: brightness(0) invert(1);
        }

        .agn-step-title {
          font-family: var(--font-primary);
          font-size: 1.1rem;
          font-weight: 800;
          color: #000;
          margin-bottom: 10px;
          text-transform: uppercase;
          letter-spacing: 1px;
        }

        .agn-step-desc {
          font-family: var(--font-secondary);
          font-size: 0.85rem;
          color: #666;
          line-height: 1.5;
          margin: 0;
          font-weight: 500;
        }

        .title-basic h2 {
          font-family: var(--font-primary);
          font-size: var(--h2-size);
          font-weight: var(--h2-weight);
          line-height: var(--lh-tight);
          margin-bottom: var(--margin-title);
          color: #000;
        }
      `}</style>
      <div className="container">
        <div className="title-basic text-center">
          <h2>

            How to Start with AGN?

          </h2>
        </div>
        <div className="row justify-content-center">
          <div className="col-lg-3 col-md-6">
            <div className="agn-step-card">
              <div className="agn-step-inner">
                <div className="agn-step-icon-box">
                  <img src="../assets/svg/home/tick.svg" alt="step" />
                </div>
                <h5 className="agn-step-title">1. Register Account
                </h5>
                <p className="agn-step-desc"> Create your AGN profile and access the platform
                </p>
              </div>
            </div>
          </div>

          <div className="col-lg-3 col-md-6">
            <div className="agn-step-card">
              <div className="agn-step-inner">
                <div className="agn-step-icon-box">
                  <img src="../assets/svg/home/tick.svg" alt="step" />
                </div>
                <h5 className="agn-step-title">2. Select Asset Plan
                </h5>
                <p className="agn-step-desc"> Choose your preferred asset level
                </p>
              </div>
            </div>
          </div>

          <div className="col-lg-3 col-md-6">
            <div className="agn-step-card">
              <div className="agn-step-inner">
                <div className="agn-step-icon-box">
                  <img src="../assets/svg/home/tick.svg" alt="step" />
                </div>
                <h5 className="agn-step-title">3.Activate Income Streams
                </h5>
                <p className="agn-step-desc"> Start earning via royalty or bonus models
                </p>
              </div>
            </div>
          </div>

          <div className="col-lg-3 col-md-6">
            <div className="agn-step-card">
              <div className="agn-step-inner">
                <div className="agn-step-icon-box">
                  <img src="../assets/svg/home/tick.svg" alt="step" />
                </div>
                <h5 className="agn-step-title">4.  Build Network</h5>
                <p className="agn-step-desc"> Enhance income through referral-based growth

                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
